










































import { ClientProfileExtended } from "@/model/communication/users/FetchClientProfilesResponse";
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            profileNameInternalString: "@$",
        };
    },
    props: {
        clientProfile: {
            type: ClientProfileExtended,
            required: true,
        },
    },
});
